import { put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  CREATE_PRODUCT_SAGA,
  END_CREATION_LOADING,
  GET_BRANDS_SAGA,
  GET_CATEGORY_FEATURES_SAGA,
  GET_CATEGORIES_SAGA,
  GET_SUBCATEGORIES_SAGA,
  GET_SECOND_SUBCATEGORIES_SAGA,
  ADD_KEYVALUE,
} from "../actionTypes";

import { apiCaller } from "../../custom-hooks/useApi";
import { addProductSteps_apiCalls } from "../../services/agent";

/////////////////////////////////////////////////
////////////// Create Product /////////////////
/////////////////////////////////////////////////

export function* addProductSaga(action) {
  const { payload } = action;

  const { status } = yield apiCaller({
    api: addProductSteps_apiCalls.apiCall_createProduct,
    apiArguments: payload,
  });

  yield put({ type: END_CREATION_LOADING, payload: status });
}

export function* watchAddProductSaga() {
  yield takeLatest(CREATE_PRODUCT_SAGA, addProductSaga);
}

/////////////////////////////////////////////////
////////////// Fetch Categories /////////////////
/////////////////////////////////////////////////
export function* getCategoriesSaga(action) {
  const { payload } = action;

  const { data, status } = yield apiCaller({
    api: addProductSteps_apiCalls.apiCall_getMasterCategories,
    toastMessage: true,
    onErrorMessage: "دریافت لیست دسته بندی ها با خطا مواجه شد .",
  });

  if (status === 200)
    yield put({
      type: ADD_KEYVALUE,
      payload: { key: "allCategoriesList", value: data.data },
    });
  yield put({ type: END_CREATION_LOADING });
}

export function* watchGetCategoriesSaga() {
  yield takeLatest(GET_CATEGORIES_SAGA, getCategoriesSaga);
}

/////////////////////////////////////////////////
////////////// Fetch SubCategories /////////////////
/////////////////////////////////////////////////
export function* getSubCategoriesListSaga(action) {
  const { payload } = action;
  const { data, status } = yield apiCaller({
    api: addProductSteps_apiCalls.apiCall_getSubCategories,
    apiArguments: payload,
    toastMessage: true,
    onErrorMessage: "دریافت لیست زیر دسته بندی ها با خطا مواجه شد .",
  });
  if (status === 200)
    yield put({
      type: ADD_KEYVALUE,
      payload: { key: "allSubCategoriesList", value: data.data },
    });
  yield put({ type: END_CREATION_LOADING });
}

export function* watchGetSubCategoriesListSaga() {
  yield takeLatest(GET_SUBCATEGORIES_SAGA, getSubCategoriesListSaga);
}

////////////////////////////////////////////////////////////
////////////// Fetch Second SubCategories //////////////////
////////////////////////////////////////////////////////////

export function* getSecondSubCategorySaga(action) {
  const { payload } = action;
  const { data, status } = yield apiCaller({
    api: addProductSteps_apiCalls.apiCall_getSubCategories,
    apiArguments: payload,
    toastMessage: true,
    onErrorMessage: "دریافت لیست زیر دسته بندی ها با خطا مواجه شد .",
  });

  if (status === 200)
    yield put({
      type: ADD_KEYVALUE,
      payload: { key: "allSecondSubCategoriesList", value: data.data },
    });
  yield put({ type: END_CREATION_LOADING });
}

export function* watchGetSecondSubCategorySaga() {
  yield takeLatest(GET_SECOND_SUBCATEGORIES_SAGA, getSecondSubCategorySaga);
}

////////////////////////////////////////////////////////////
////////////// Fetch SubCategory Features //////////////////
////////////////////////////////////////////////////////////

export function* getCategoryFeaturesSaga(action) {
  const { payload } = action;
  const { data, status } = yield apiCaller({
    api: addProductSteps_apiCalls.apiCall_getSubCategorieFeatures,
    apiArguments: payload,
    toastMessage: true,
    onErrorMessage: "دریافت لیست ویژگی ها با خطا مواجه شد .",
  });

  if (status === 200)
    yield put({
      type: ADD_KEYVALUE,
      payload: { key: "allFeatures", value: data.data },
    });
  yield put({ type: END_CREATION_LOADING });
}

export function* watchGetCategoryFeaturesSaga() {
  yield takeLatest(GET_CATEGORY_FEATURES_SAGA, getCategoryFeaturesSaga);
}

////////////////////////////////////////////////////////////
////////////// Fetch Brands //////////////////
////////////////////////////////////////////////////////////

export function* getBrandsSaga(action) {
  const { data, status } = yield apiCaller({
    api: addProductSteps_apiCalls.apiCall_getBrands,
    toastMessage: true,
    onErrorMessage: "دریافت لیست برند ها با خطا مواجه شد .",
  });

  if (status === 200)
    yield put({
      type: ADD_KEYVALUE,
      payload: { key: "allBrands", value: data.data },
    });
  yield put({ type: END_CREATION_LOADING });
}

export function* watchGetBrandsSaga() {
  yield takeLatest(GET_BRANDS_SAGA, getBrandsSaga);
}
